import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import type {
  StaffSpecialistsQueryParams,
  StaffSpecialistsResponse,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const staffSpecialistKeys = {
  all: () => ['staffSpecialists'] as const,
  list: (props: StaffSpecialistsQueryParams) =>
    [...staffSpecialistKeys.all(), 'list', props.url] as const,
};

export const staffSpecialistQueries = {
  list: (props: StaffSpecialistsQueryParams) =>
    queryOptions({
      queryKey: staffSpecialistKeys.list(props),
      queryFn: () =>
        HttpClient.request<StaffSpecialistsResponse>({
          method: 'GET',
          url: props.url,
        }),
      enabled: !!props.url,
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
    }),
};
